import { Author } from "../manifest/models/author.models";
import { BuzzfeedQuiz } from "../manifest/models/quiz.models";
import { PostController } from "./post.controller";

export type PostEvent = (post: PostData) => void;

export interface PostProps {
  controller: PostController<PostData>;
  showValidationErrors: boolean;
  hasErrors: boolean;
  user: Author;
}

export interface PostStateMixin {
  userShared: boolean;
  displayShareSnackbar: boolean;
  userLiked: boolean;
  userDisliked: boolean;
  viewingReplies: boolean;
  displayReplyFollowup: boolean;
}

export type PostDataType =
  | "single-image-view"
  | "youtube-video"
  | "buzzfeed-quiz"
  | "paginated-article"
  | "image-infographic"
  | "goal-feedback";

export interface PostComment {
  id: string;
  body: string;
  likeCount?: number;
  author?: string;
  date?: string;
  avatar?: string;
}

export enum FollowupAction {
  like,
}

export interface ReplyFollowup {
  action: FollowupAction;
  delay: number;
  user: Author;
  metadata: { [key: string]: any };
}

export interface SponsoredImagePost extends BasicImagePost {
  url: string;
}

export interface BasicImagePost extends PostData {
  image: string;
}

export interface YoutubeVideoPost extends PostData {
  url: string;
  title?: string;
}

export interface GoalFeedbackPost extends PostData {
  goals: string;
}

export interface BuzzfeedQuizPost extends PostData {
  quiz: BuzzfeedQuiz;
}

export interface PaginatedArticlePost extends PostData {
  pages: string[];
}

export type PostContentType =
  | "meme"
  | "advertisement"
  | "article"
  | "infographic"
  | "neutral-infographic"
  | "quiz"
  | "video"
  | "filler"
  | "friend-post"
  | "goal-feedback";

export interface PostData {
  id: string;
  type: PostDataType;
  contentType?: PostContentType;
  tags?: string[];
  likes?: number;
  dislikes?: number;
  shares?: number;
  title?: string;
  pdf?: string;
  width?: number;
  height?: number;
  author?: string;
  avatar?: string;
  date?: string;
  dateOffset?: number;
  advertisementStyle?: boolean;
  comments?: PostComment[];
  includesComments?: boolean;
  userFollowup?: ReplyFollowup;
}
